import(/* webpackMode: "eager" */ "/home/runner/work/kst-frontend/kst-frontend/app/testimonials/page.tsx")